import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ehrCredentials: null,
  ehrCredentialsLoading: false,
  ehrCallbackSuccess: false,
  ehrCredentialsSuccess: null,
};

const ehrCredentialsSlice = createSlice({
  name: 'ehrCredentialsSlice',
  initialState,
  reducers: {
    getEhrCredentialsSlice: (state, { payload }) => {
      state.ehrCredentials = payload;
    },
    ehrCredentialsLoadingSlice: (state, { payload }) => {
      state.ehrCredentialsLoading = payload;
    },
    ehrCredentialsSuccessSlice: (state, { payload }) => {
      state.ehrCredentialsSuccess = payload;
    },
    ehrCallbackSuccessSlice: (state, { payload }) => {
      state.ehrCallbackSuccess = payload;
    },
  },
});

const { actions, reducer } = ehrCredentialsSlice;

export const {
  getEhrCredentialsSlice,
  ehrCredentialsLoadingSlice,
  ehrCredentialsSuccessSlice,
  ehrCallbackSuccessSlice,
} = actions;

export default reducer;
